import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import { STEPS_LABELS } from './constants';
import { setCurrentStep } from './store/actions/stepper';
import { isCreatingRunRecords } from './store/run_records_selectors';
import { getImportStatus } from './store/record_table_ui_selectors';
import FilesList from './files-list';
import Review from './review/review';

export function NewImportReview({ setCurrentStep }) {

  useEffect(() => {
    setCurrentStep(STEPS_LABELS.REVIEW);
  }, []);

  const renderImportMapping = () => {
    return (
      <Row>
        <Col lg={3} md={3} sm={4} xs={2}>
          <FilesList />
        </Col>
        <Col lg={9} md={9} sm={8} xs={10}>
          <Review />
        </Col>
      </Row>
    );
  };

  return (
    <React.Fragment>
      <div className="w-100 d-flex flex-column">
        <div className="container importer-imports imports-index">
          {renderImportMapping()}
        </div>
      </div>
    </React.Fragment>
  );
}

NewImportReview.propTypes = {
  creatingRunRecords: PropTypes.bool,
  importStatus: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  creatingRunRecords: isCreatingRunRecords(state),
  importStatus: getImportStatus(state)
});

const mapDispatchToProps = {
  setCurrentStep
};

export default connect(mapStateToProps, mapDispatchToProps)(NewImportReview);
